module.exports = __webpack_public_path__ + "img/Daily-Downloads-of-MongoDB-Related-Packages-300x257.7aaff97d.png";